import type { ButtonHTMLAttributes } from 'react';
import { Loader } from 'react-feather';

type ButtonVariant = 'primary' | 'secondary' | 'warning' | 'danger' | 'success';
type PrimaryProps = ButtonHTMLAttributes<HTMLButtonElement> & {
    children: React.ReactNode;
    variant?: ButtonVariant;
    isLoading?: boolean;
};

export function Button({ children, variant = 'primary', className = '', isLoading, ...props }: PrimaryProps) {
    const colors: Record<ButtonVariant, string> = {
        primary: 'bg-gradient-to-r from-[#b78bff] via-[#8f7dff] to-[#4b7bff] text-white shadow-[0_18px_40px_-22px_rgba(55,32,120,0.55)] hover:shadow-[0_24px_50px_-22px_rgba(55,32,120,0.6)]',
        secondary: 'bg-[#efe9ff] text-[#3a2b66] shadow-[0_12px_30px_-20px_rgba(55,32,120,0.25)] hover:bg-[#e7dfff]',
        success: 'bg-success text-white',
        warning: 'bg-warning text-white',
        danger: 'bg-danger text-white',
    };

    const color = colors[variant];
    const disabled = props.disabled || isLoading;

    return (
        <button
            {...props}
            disabled={disabled}
            className={`inline-flex items-center justify-center gap-2 rounded-full px-7 py-3 text-base font-semibold tracking-wide transition-all duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/40 disabled:opacity-60 disabled:cursor-not-allowed disabled:pointer-events-none hover:-translate-y-0.5 active:translate-y-0 ${color} ${className}`}
        >
            {!!isLoading && <Loader className="inline h-4 w-4 animate-spin" />}
            <span>{children}</span>
        </button>
    );
}
